import {default as HeaderBar} from './HeaderBar-Component'
export default HeaderBar